import { AgDialog } from '@australiangreens/ag-internal-components';

type WarningChangeStatusDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  currentlyAssignedUser: string;
  buttonName: string;
  handleUpdateCallingStatus: () => Promise<void>;
  confirmDisabled?: boolean;
};

const WarningChangeStatusDialog = ({
  isOpen,
  onClose,
  currentlyAssignedUser,
  buttonName,
  handleUpdateCallingStatus,
  confirmDisabled = false,
}: WarningChangeStatusDialogProps) => {
  const dialogTitle = currentlyAssignedUser
    ? "Update another user's contact?"
    : 'Update unassigned contact?';

  return (
    <AgDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle={dialogTitle}
      primaryButton={{
        text: buttonName,
        onClick: handleUpdateCallingStatus,
        disabled: confirmDisabled,
      }}
    >
      <div>
        {!currentlyAssignedUser && (
          <>
            <p style={{ marginTop: 0 }}>
              This contact is currently unassigned. Are you sure you want to change the calling
              status?
            </p>
            <p>
              <em>
                Note: updating the status will assign this contact to you. You can assign contacts
                on the Dashboard.
              </em>
            </p>
          </>
        )}

        {currentlyAssignedUser && (
          <>
            <p style={{ marginTop: 0 }}>
              This contact is currently assigned to <strong>{currentlyAssignedUser}</strong>. Are
              you sure you want to change the calling status?
            </p>
            <p>
              <em>
                Note: updating the status will assign this contact to you. Make sure to let{' '}
                <strong>{currentlyAssignedUser}</strong> know.
              </em>
            </p>
          </>
        )}
      </div>
    </AgDialog>
  );
};

export default WarningChangeStatusDialog;
